import { lazy } from 'react';

import { LoginRouteBase } from '@/App/AppRoutes/LoginRouteBase';
import type { AppRouteConfig } from '@/App/AppRoutes/types';

const LoginPage = lazy(() => import('@/components/pages/LoginPage').then(({ LoginPage }) => ({ default: LoginPage })));

export const LoginRoute: AppRouteConfig = {
  ...LoginRouteBase,
  component: LoginPage,
};
